import { render, staticRenderFns } from "./ExSpinner.vue?vue&type=template&id=6ecbf281&scoped=true"
import script from "./ExSpinner.vue?vue&type=script&lang=js"
export * from "./ExSpinner.vue?vue&type=script&lang=js"
import style0 from "./ExSpinner.vue?vue&type=style&index=0&id=6ecbf281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecbf281",
  null
  
)

export default component.exports